/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssistantPromptRequestDto,
  AssistantPromptResponseDto,
  FetchAllSectionsDataResponseDto,
  FetchSectionsDataRequestDto,
  FetchSectionsDataResponseDto,
  GeneratePresentationPdfResponseDto,
  PresentationConfigDto,
  SharePresentationByEmailRequestDto,
  UploadSectionFileResponseDto,
} from '../models/index';
import {
    AssistantPromptRequestDtoFromJSON,
    AssistantPromptRequestDtoToJSON,
    AssistantPromptResponseDtoFromJSON,
    AssistantPromptResponseDtoToJSON,
    FetchAllSectionsDataResponseDtoFromJSON,
    FetchAllSectionsDataResponseDtoToJSON,
    FetchSectionsDataRequestDtoFromJSON,
    FetchSectionsDataRequestDtoToJSON,
    FetchSectionsDataResponseDtoFromJSON,
    FetchSectionsDataResponseDtoToJSON,
    GeneratePresentationPdfResponseDtoFromJSON,
    GeneratePresentationPdfResponseDtoToJSON,
    PresentationConfigDtoFromJSON,
    PresentationConfigDtoToJSON,
    SharePresentationByEmailRequestDtoFromJSON,
    SharePresentationByEmailRequestDtoToJSON,
    UploadSectionFileResponseDtoFromJSON,
    UploadSectionFileResponseDtoToJSON,
} from '../models/index';

export interface CMAPresentationControllerFetchAllSectionsDataRequest {
    id: string;
}

export interface CMAPresentationControllerFetchSectionsDataRequest {
    id: string;
    fetchSectionsDataRequestDto: FetchSectionsDataRequestDto;
}

export interface CMAPresentationControllerGeneratePdfUrlRequest {
    id: string;
    frontendPrintUrl?: string;
    isAttachment?: any;
}

export interface CMAPresentationControllerGetAnswerFromAssistantRequest {
    assistantPromptRequestDto: AssistantPromptRequestDto;
}

export interface CMAPresentationControllerGetEditRequest {
    id: string;
}

export interface CMAPresentationControllerGetViewRequest {
    id: string;
}

export interface CMAPresentationControllerPatchConfigRequest {
    id: string;
    presentationConfigDto: PresentationConfigDto;
}

export interface CMAPresentationControllerSendShareEmailRequest {
    id: string;
    sharePresentationByEmailRequestDto: SharePresentationByEmailRequestDto;
}

export interface CMAPresentationControllerUploadSectionFileRequest {
    id: string;
    sectionId: string;
    file: Blob;
}

/**
 * 
 */
export class CMAPresentationApi extends runtime.BaseAPI {

    /**
     * Force all sections to fetch data from the backend.
     */
    async cMAPresentationControllerFetchAllSectionsDataRaw(requestParameters: CMAPresentationControllerFetchAllSectionsDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchAllSectionsDataResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAPresentationControllerFetchAllSectionsData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cma-presentations/{id}/all-sections/data`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FetchAllSectionsDataResponseDtoFromJSON(jsonValue));
    }

    /**
     * Force all sections to fetch data from the backend.
     */
    async cMAPresentationControllerFetchAllSectionsData(requestParameters: CMAPresentationControllerFetchAllSectionsDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchAllSectionsDataResponseDto> {
        const response = await this.cMAPresentationControllerFetchAllSectionsDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Force some sections to fetch data from the backend.
     */
    async cMAPresentationControllerFetchSectionsDataRaw(requestParameters: CMAPresentationControllerFetchSectionsDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchSectionsDataResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAPresentationControllerFetchSectionsData().'
            );
        }

        if (requestParameters['fetchSectionsDataRequestDto'] == null) {
            throw new runtime.RequiredError(
                'fetchSectionsDataRequestDto',
                'Required parameter "fetchSectionsDataRequestDto" was null or undefined when calling cMAPresentationControllerFetchSectionsData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cma-presentations/{id}/sections/data`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FetchSectionsDataRequestDtoToJSON(requestParameters['fetchSectionsDataRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FetchSectionsDataResponseDtoFromJSON(jsonValue));
    }

    /**
     * Force some sections to fetch data from the backend.
     */
    async cMAPresentationControllerFetchSectionsData(requestParameters: CMAPresentationControllerFetchSectionsDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchSectionsDataResponseDto> {
        const response = await this.cMAPresentationControllerFetchSectionsDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates a presentation PDF and returns the url to access it.
     */
    async cMAPresentationControllerGeneratePdfUrlRaw(requestParameters: CMAPresentationControllerGeneratePdfUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneratePresentationPdfResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAPresentationControllerGeneratePdfUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['frontendPrintUrl'] != null) {
            queryParameters['frontendPrintUrl'] = requestParameters['frontendPrintUrl'];
        }

        if (requestParameters['isAttachment'] != null) {
            queryParameters['isAttachment'] = requestParameters['isAttachment'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cma-presentations/{id}/pdf-url`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneratePresentationPdfResponseDtoFromJSON(jsonValue));
    }

    /**
     * Generates a presentation PDF and returns the url to access it.
     */
    async cMAPresentationControllerGeneratePdfUrl(requestParameters: CMAPresentationControllerGeneratePdfUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneratePresentationPdfResponseDto> {
        const response = await this.cMAPresentationControllerGeneratePdfUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a answer from the AI assistant. Used to support the AI Assisted Text widget.
     * 
     */
    async cMAPresentationControllerGetAnswerFromAssistantRaw(requestParameters: CMAPresentationControllerGetAnswerFromAssistantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistantPromptResponseDto>> {
        if (requestParameters['assistantPromptRequestDto'] == null) {
            throw new runtime.RequiredError(
                'assistantPromptRequestDto',
                'Required parameter "assistantPromptRequestDto" was null or undefined when calling cMAPresentationControllerGetAnswerFromAssistant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cma-presentations/assistant/answer`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistantPromptRequestDtoToJSON(requestParameters['assistantPromptRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistantPromptResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns a answer from the AI assistant. Used to support the AI Assisted Text widget.
     * 
     */
    async cMAPresentationControllerGetAnswerFromAssistant(requestParameters: CMAPresentationControllerGetAnswerFromAssistantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistantPromptResponseDto> {
        const response = await this.cMAPresentationControllerGetAnswerFromAssistantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the editable data for a PresentationView
     * 
     */
    async cMAPresentationControllerGetEditRaw(requestParameters: CMAPresentationControllerGetEditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAPresentationControllerGetEdit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cma-presentations/{id}/edit`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Returns the editable data for a PresentationView
     * 
     */
    async cMAPresentationControllerGetEdit(requestParameters: CMAPresentationControllerGetEditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAPresentationControllerGetEditRaw(requestParameters, initOverrides);
    }

    /**
     * Returns a fake file. Only available on development.
     * 
     */
    async cMAPresentationControllerGetFileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cma-presentations/file/fake/*`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Returns a fake file. Only available on development.
     * 
     */
    async cMAPresentationControllerGetFile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAPresentationControllerGetFileRaw(initOverrides);
    }

    /**
     * Returns a single PresentationView
     * 
     */
    async cMAPresentationControllerGetViewRaw(requestParameters: CMAPresentationControllerGetViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAPresentationControllerGetView().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cma-presentations/{id}/view`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Returns a single PresentationView
     * 
     */
    async cMAPresentationControllerGetView(requestParameters: CMAPresentationControllerGetViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAPresentationControllerGetViewRaw(requestParameters, initOverrides);
    }

    /**
     * Updates a Presentation View
     * 
     */
    async cMAPresentationControllerPatchConfigRaw(requestParameters: CMAPresentationControllerPatchConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAPresentationControllerPatchConfig().'
            );
        }

        if (requestParameters['presentationConfigDto'] == null) {
            throw new runtime.RequiredError(
                'presentationConfigDto',
                'Required parameter "presentationConfigDto" was null or undefined when calling cMAPresentationControllerPatchConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cma-presentations/{id}/edit`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PresentationConfigDtoToJSON(requestParameters['presentationConfigDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates a Presentation View
     * 
     */
    async cMAPresentationControllerPatchConfig(requestParameters: CMAPresentationControllerPatchConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAPresentationControllerPatchConfigRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAPresentationControllerSendShareEmailRaw(requestParameters: CMAPresentationControllerSendShareEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAPresentationControllerSendShareEmail().'
            );
        }

        if (requestParameters['sharePresentationByEmailRequestDto'] == null) {
            throw new runtime.RequiredError(
                'sharePresentationByEmailRequestDto',
                'Required parameter "sharePresentationByEmailRequestDto" was null or undefined when calling cMAPresentationControllerSendShareEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cma-presentations/{id}/share/email`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SharePresentationByEmailRequestDtoToJSON(requestParameters['sharePresentationByEmailRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAPresentationControllerSendShareEmail(requestParameters: CMAPresentationControllerSendShareEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAPresentationControllerSendShareEmailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAPresentationControllerUploadSectionFileRaw(requestParameters: CMAPresentationControllerUploadSectionFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadSectionFileResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAPresentationControllerUploadSectionFile().'
            );
        }

        if (requestParameters['sectionId'] == null) {
            throw new runtime.RequiredError(
                'sectionId',
                'Required parameter "sectionId" was null or undefined when calling cMAPresentationControllerUploadSectionFile().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling cMAPresentationControllerUploadSectionFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/comps/cma-presentations/{id}/sections/{sectionId}/files`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters['sectionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadSectionFileResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async cMAPresentationControllerUploadSectionFile(requestParameters: CMAPresentationControllerUploadSectionFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadSectionFileResponseDto> {
        const response = await this.cMAPresentationControllerUploadSectionFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
